import React from "react";

interface ClickableProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
}

const Clickable : React.FC<ClickableProps> = ({children, onClick, className, ...props}) => {
    return <div 
        className={`cursor-pointer hover:bg-brand-bg-6 ${className}`} 
        onClick={onClick}
        {...props}
    >
        {children}
    </div>
}

export default Clickable;